import { ArtworkDetailActionTypes, ArtworkDetailType } from "../types/artwork-detail.type";
import { IArtwork } from "../../types/artwork/artwork";

export const setArtworkDetail = (payload: IArtwork | null): ArtworkDetailType => ({
  type: ArtworkDetailActionTypes.ADD_ARTWORK,
  payload,
});
